<template>
  <div>
    <div class="alert alert-danger" v-if="errorMsg">{{ errorMsg }}</div>

    <div class="row mb-2">
      <div class="col-auto">
        <button class="btn btn-primary gdq_faded gdq-font-size-80" @click="addNew">
          <span class="icon-plus mr-1"></span>Add material
        </button>
      </div>
    </div>

    <div class="card mb-3" v-if="showForm">
      <div class="card-body">
        <h6 class="card-title">{{ editing.id > 0 ? 'Edit material' : 'New material' }}</h6>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="mb-3 d-flex align-items-center">
              <label class="col-form-label" style="width: 33%; flex-shrink: 0">Kind</label>
              <div style="width: 67%">
                <select class="form-select" v-model="editing.kind">
                  <option value="document">Document</option>
                  <option value="literature">Literature</option>
                </select>
              </div>
            </div>
            <div class="mb-3 d-flex align-items-center">
              <label class="col-form-label" style="width: 33%; flex-shrink: 0">Title</label>
              <div style="width: 67%"><input class="form-control" v-model="editing.title" /></div>
            </div>
            <div class="mb-3 d-flex align-items-center">
              <label class="col-form-label" style="width: 33%; flex-shrink: 0">Description</label>
              <div style="width: 67%"><input class="form-control" v-model="editing.description" /></div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="mb-3 d-flex align-items-center">
              <label class="col-form-label" style="width: 33%; flex-shrink: 0">Embed type</label>
              <div style="width: 67%">
                <select class="form-select" v-model="editing.embed_type">
                  <option value="">None</option>
                  <option value="office">Office viewer</option>
                  <option value="pdf">PDF</option>
                  <option value="video">Video</option>
                </select>
              </div>
            </div>
            <div class="mb-3 d-flex align-items-center">
              <label class="col-form-label" style="width: 33%; flex-shrink: 0">Embed URL</label>
              <div style="width: 67%"><input class="form-control" v-model="editing.embed_url" /></div>
            </div>
            <div class="mb-3 d-flex align-items-center">
              <label class="col-form-label" style="width: 33%; flex-shrink: 0">Open URL</label>
              <div style="width: 67%"><input class="form-control" v-model="editing.open_url" /></div>
            </div>
          </div>
        </div>
        <div>
          <button class="btn btn-outline-secondary" @click="cancel">Cancel</button>
          <button class="btn btn-primary float-end" :disabled="saving" @click="save">
            <fa-icon name="check" />Save
          </button>
        </div>
      </div>
    </div>

    <table class="table table-hover lh-table">
      <thead>
        <tr>
          <th style="width: 40px;">#</th>
          <th>Kind</th>
          <th>Title</th>
          <th>Description</th>
          <th>Embed</th>
          <th style="width: 110px;">⚡</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, i) in rows" :key="item.id" style="cursor: pointer;" @click="editRow(item)">
          <td>{{ item.sort }}</td>
          <td>{{ item.kind }}</td>
          <td>{{ item.title }}</td>
          <td>{{ item.description || '-' }}</td>
          <td>
            <span class="badge bg-light text-dark" v-if="item.embed_type">{{ item.embed_type }}</span>
            <span v-else>-</span>
          </td>
          <td>
            <span class="me-2" style="cursor: pointer;" title="Move up" v-if="i > 0" @click.prevent.stop="move(item, i, -1)">
              <fa-icon name="arrow-up" />
            </span>
            <span class="me-2" style="cursor: pointer;" title="Move down" v-if="i < rows.length - 1" @click.prevent.stop="move(item, i, 1)">
              <fa-icon name="arrow-down" />
            </span>
            <span style="cursor: pointer;" title="Delete" @click.prevent.stop="delRow(item)">
              <fa-icon name="trash-alt" />
            </span>
          </td>
        </tr>
        <tr v-if="rows.length === 0">
          <td colspan="6" class="text-center text-muted py-3">No materials</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'LHCourseMaterials',
  props: {
    courseId: { type: Number, required: true },
    rows: { type: Array, required: true }
  },
  data () {
    return {
      showForm: false,
      saving: false,
      errorMsg: '',
      editing: this.emptyRow()
    }
  },
  methods: {
    emptyRow () {
      return {
        id: 0, sort: 0, kind: 'document', title: '', description: '',
        embed_type: '', embed_url: '', open_url: ''
      }
    },
    addNew () {
      this.errorMsg = ''
      this.editing = this.emptyRow()
      this.editing.sort = this.rows.length + 1
      this.showForm = true
    },
    editRow (r) {
      this.errorMsg = ''
      this.editing = { ...r }
      this.showForm = true
    },
    cancel () {
      this.showForm = false
    },
    async save () {
      this.saving = true
      this.errorMsg = ''
      try {
        const body = {
          sort: this.editing.sort,
          kind: this.editing.kind,
          title: this.editing.title,
          description: this.editing.description,
          embed_type: this.editing.embed_type,
          embed_url: this.editing.embed_url,
          open_url: this.editing.open_url
        }
        if (this.editing.id > 0) {
          await this.$store.dispatch('learninghub_material_update', { id: this.editing.id, body })
        } else {
          body.course_id = this.courseId
          await this.$store.dispatch('learninghub_material_save', { body })
        }
        this.showForm = false
        this.$emit('changed')
      } catch (e) {
        this.errorMsg = e.response && e.response.data && typeof e.response.data.result === 'string'
          ? e.response.data.result : (e.message || 'Save failed')
      }
      this.saving = false
    },
    async delRow (r) {
      if (!confirm('Delete material "' + r.title + '"?')) return
      try {
        await this.$store.dispatch('learninghub_material_delete', { id: r.id })
        this.$emit('changed')
      } catch (e) {
        this.errorMsg = e.response && e.response.data && typeof e.response.data.result === 'string'
          ? e.response.data.result : (e.message || 'Delete failed')
      }
    },
    async move (item, i, dir) {
      const ids = this.rows.map(x => x.id)
      const j = i + dir
      ;[ids[i], ids[j]] = [ids[j], ids[i]]
      try {
        await this.$store.dispatch('learninghub_reorder', { body: { entity: 'material', ids } })
        this.$emit('changed')
      } catch (e) {
        this.errorMsg = e.message || 'Reorder failed'
      }
    }
  }
}
</script>

<style>
.lh-table {
  font-size: 0.9rem !important;
}
</style>
